import React, { useState, useEffect } from 'react';
import QrReader from 'react-qr-scanner';
import {
    IconPlayerPlayFilled,
    IconVinyl
} from '@tabler/icons-react';

function CardGame(props) {

    const [showScanner, setShowScanner] = useState(true);
    const [trackData, setTrackData] = useState(null);
    const [reveal, setReveal] = useState(false);
    const [showPlayer, setShowPlayer] = useState(false);

    const [logEnabled] = useState(false);
    const [log, setLog] = useState([]);

    useEffect(() => {                        
    }, []);

    function logMsg(msg) {
        if (logEnabled) setLog([...log, msg]);
    }

    function revealAnswer() {
        logMsg('Reveal clicked!');
        setReveal(true);
        if (!trackData) {
            setShowPlayer(true);
        }
    }

    function handleScan(data){
        if (data && data.text) {
            setShowScanner(false);

            if (props.expiration) {
                const nowDate = new Date();
                const expirationDate = new Date(props.expiration);
                if (expirationDate <= nowDate) {
                    sessionStorage.clear();
                    window.location.reload();
                }
            }

            window.onSpotifyIframeApiReady = (IFrameAPI) => {
                
                var frame = document.createElement("div");
                frame.setAttribute("id", "embed-iframe");
                document.getElementById('embed-wrapper').appendChild(frame);

                const element = document.getElementById('embed-iframe');
                const options = {
                    uri: 'spotify:track:'+data.text
                  };
                const callback = (EmbedController) => {
                    window.controller = EmbedController;
                    document.querySelectorAll('.scanBtn').forEach(
                        btn => {
                          btn.addEventListener('click', () => {
                            EmbedController.destroy();
                          });
                        }
                    );

                    setTimeout(() => {
                        EmbedController.togglePlay();
                    }, 1500);
                    
                };
                IFrameAPI.createController(element, options, callback);
            };

            logMsg('Calling API: https://api.spotify.com/v1/tracks/'+data.text);
            fetch('https://api.spotify.com/v1/tracks/'+data.text, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + props.token
                }
            })
            .then(response => {
                if (!response.ok) {
                    logMsg('API failed: ' + response.status);
                    if (response.statusText) {
                        logMsg(response.statusText);
                    }
                }
                return response.json()
            })
            .then(data => {
                logMsg('API success: ' + data.name);
                setTrackData(data);
            });
        }
    }

    function handleError(err){
        console.error(err)
    }

    function scanClicked() {
        setShowScanner(true);
        setReveal(false);
        setShowPlayer(false);
        setTrackData(null);
    }

    function togglePlayClicked() {
        if (window.controller) {
            window.controller.togglePlay();
        }
    }

    function renderScanner() {
        if (showScanner) {
            return (
                <QrReader
                    delay={1000}
                    style={previewStyle}
                    onError={handleError}
                    onScan={handleScan}
                    constraints={ { video: { facingMode: { ideal: 'environment' } } } } />
            );
        }
    }

    function renderScanButton() {
        if (!showScanner) {
            return (
                <button className='scanBtn btn-spotify' onClick={scanClicked}>Scan</button>
            );
        }
    }

    function renderPlayer() {
        let button = showScanner ? null : (
            <button className='btn-player playBtn btn-spotify' onClick={togglePlayClicked}>
                <IconPlayerPlayFilled></IconPlayerPlayFilled>
            </button>
        );
        return (
            <>
                <div id="embed-wrapper" className={showPlayer ? 'showPlayer' : ''}></div>
                <div>
                    {button}
                </div>
            </>
        );
    }

    function renderCard() {
        if (!showScanner) {
            if (props.token && trackData) {
                if (reveal) {
                    return (
                        <div id="embed-overlay">
                            <div id="reveal-artist">{trackData.artists[0].name}</div>
                            <div id="reveal-track">{trackData.name}</div>
                        </div>
                    );
                } else {
                    return (
                        <div id="embed-overlay" onClick={revealAnswer}>
                            <div id="reveal-prompt">Click to Reveal</div>
                        </div>
                    );
                }
            } else {
                <div id="embed-overlay">
                    <div id="reveal-prompt">Click to Reveal</div>
                </div>
            }

            if (reveal) {
                if (trackData) {
                    return (
                        <div id="embed-overlay">
                            <div id="reveal-artist">{trackData.artists[0].name}</div>
                            <div id="reveal-track">{trackData.name}</div>
                        </div>
                    );
                }               
            } else {
                return (
                    <div id="embed-overlay">
                        <div id="reveal-prompt"><IconVinyl size={72} /></div>
                    </div>
                );
            }
        }
    }

    function renderStandaloneAd() {
        return (
            <div id="ad">
                Enjoying the game?<br />You can play solo anytime!<br />No QR codes. No team.<br />Think you can get 10+ songs in your timeline?<br /><br />hitster.zachwerden.com
            </div>
        );
    }

    function renderLog() {
        if (logEnabled) {
            var messages = log.map(function(msg) {
                return (
                  <div className="log-msg">
                    {msg}
                  </div>
                )
              });
            return (
                <div id="log">
                    {messages}
                </div>
            );
        }
    }

    const previewStyle = {
        height: '80vh',
        width: '100%',
        margin: 'auto'
    }

    return (
        <div className='wrapper card'>
            {renderScanner()}
            {renderScanButton()}
            {renderCard()}
            {renderPlayer()}
            {renderStandaloneAd()}

            {renderLog()}
        </div>
    );
}

export default CardGame
